import BaseTooltip from "../BaseTooltip";

function BaseImagesList({ files = [] }) {
  return (
    <div className={`grid grid-cols-${files?.length > 4 ? "4" : files?.length} gap-4 mb-4 ml-4`}>
      {files?.map((file) => {
        const name = file?.fileName?.toLowerCase() ?? "";
        const isImage = /\.(jpe?g|png|webp|gif)$/.test(name);
        const isPDF = name.endsWith(".pdf");
        const isDoc = /\.docx?$/.test(name);
        const isSheet = /\.(csv|xlsx?|xlsm)$/.test(name);

        return (
          <div
            key={file?.id}
            className="relative group w-20 h-20 rounded overflow-hidden border bg-gray-100 flex items-center justify-center cursor-pointer"
          >
            {isImage ? (
              <img src={file.url} alt={file.fileName} className="object-cover w-full h-full" />
            ) : (
              <div className="flex flex-col items-center text-xs text-center p-1">
                {isPDF ? (
                  <i className="fa-solid fa-file-pdf text-red-500 text-2xl"></i>
                ) : isDoc ? (
                  <i className="fa-solid fa-file-word text-blue-500 text-2xl"></i>
                ) : isSheet ? (
                  <i className="fa-solid fa-file-excel text-green-600 text-2xl"></i>
                ) : (
                  <i className="fa-solid fa-file text-gray-500 text-2xl"></i>
                )}
                <BaseTooltip>
                  <span className="truncate w-16">{file.fileName}</span>
                </BaseTooltip>
              </div>
            )}

            <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 hover:opacity-100 transition flex items-center justify-center">
              <a
                href={file.url}
                download={file.fileName}
                target="_blank"
                rel="noopener noreferrer"
                className="text-xl"
              >
                <i className="fa-solid fa-download text-white"></i>
              </a>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default BaseImagesList;
